// extracted by mini-css-extract-plugin
export default {"content":"travelbanner_content__Soc5d","wrapper":"travelbanner_wrapper__uMhas","right":"travelbanner_right__LPIM1","left":"travelbanner_left__trV99"};